import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import { BaseEmptyPage } from 'design-system';
import React from 'react';
import { Navigate } from 'react-router-dom';

const EnvVarScreen = (): JSX.Element => {
  if (process.env.REACT_APP_EXPOSE_ENV !== 'true') {
    return <Navigate to="/" />;
  }

  function renderRow(key: string): React.ReactNode {
    return (
      <TableRow key={key}>
        <TableCell>{key}</TableCell>
        <TableCell>{process.env[key]}</TableCell>
      </TableRow>
    );
  }

  // env variables starting with REACT_APP
  const defaultEnvVariables = Object.keys(process.env)
    .filter((key: string): boolean => key.startsWith('REACT_APP'))
    .map(renderRow);

  // Other env variables
  const additionalEnvVariables = Object.keys(process.env)
    .filter((key: string): boolean => !key.startsWith('REACT_APP'))
    .map(renderRow);

  return (
    <BaseEmptyPage>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="body1">
            Env variables defined by us (Start with REACT_APP)
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Variable Name</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{defaultEnvVariables}</TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <br />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1">Additional env variables</Typography>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Variable Name</TableCell>
                  <TableCell>Value</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{additionalEnvVariables}</TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </BaseEmptyPage>
  );
};

export default EnvVarScreen;
